import { render, staticRenderFns } from "./CadFornecedor.vue?vue&type=template&id=5faeb056&"
import script from "./CadFornecedor.vue?vue&type=script&lang=js&"
export * from "./CadFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports